// Angular
import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

// Ionic
import {
  AlertController,
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonInput,
  IonItem,
  IonTitle,
  IonToolbar,
  ModalController,
  NavParams,
} from '@ionic/angular/standalone';

// Local library
import {
  DecimalInputDirective,
  UnsubscribeObservableService,
  FormatAmountPipe
} from '@amwager/util';
import { FundingComponent } from '@amwager/funding/feature-ion';
import { AccountFacade } from '@amwager/account/data-access';
import { WagerFacade } from '@amwager/wager/data-access';


@Component({
  selector: 'feature-ion-amwager3-bet-amount',
  templateUrl: './bet-amount.component.html',
  styleUrls: ['./bet-amount.component.scss'],
  imports: [
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonTitle,
    IonContent,
    IonItem,
    IonInput,
    DecimalInputDirective,
    FormsModule,
    CommonModule,
    FormatAmountPipe
  ],
  standalone: true
})
export class BetAmountComponent extends UnsubscribeObservableService implements OnInit {

  amount!: number;
  balanceAmount!: number;
  receivedData!: any;

  betAmounts: number[] = [0.1, 0.20, 0.5, 1, 2, 3, 4, 5, 10, 20, 50, 100, 200, 500, 1000];
  showBetAmounts: number[] = [];
  // betAmounts: number[] = [1, 2, 3, 4, 5, 10, 20, 50, 100, 200, 500];
  minBet!: number;
  maxBet!: number;
  showConfirmBtn: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private readonly alertCtrl: AlertController,
    private readonly accountFacade: AccountFacade,
    private readonly wagerFacade: WagerFacade,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) {

    super();
  }

  ngOnInit() {
    null;

    this.receivedData = this.navParams.get('pool');
    this.balanceAmount = 0;

    if (this.receivedData !== undefined) {
      this.minBet = this.receivedData.WagerMinimum;
      this.maxBet = this.receivedData.WBMaximum;

      // this.betAmounts = [this.minBet, ...this.betAmounts, this.maxBet];

      // this.betAmounts = this.betAmounts.includes(this.minBet) ?
      // [...this.betAmounts] : [this.minBet, ...this.betAmounts];

      // if (!this.betAmounts.includes(this.maxBet)) {
      //   this.betAmounts.push(this.maxBet);
      // }

      this.betAmounts.forEach((amount)=>{
        if(
            (
              (
                !this.receivedData.Multiple &&
                amount >= this.receivedData.MultipleBetMinimum &&
                amount <= this.receivedData.WBMaximum
              ) ||
              (
                this.receivedData.Multiple &&
                amount >= this.receivedData.MultipleBetMinimum &&
                amount <= this.receivedData.WBMaximum &&
                (
                  (amount * 100) % (this.receivedData.MultipleBetMinimum * 100)
                ) === 0
              )
            ) || amount == 0.001
          )
        {
          this.showBetAmounts.push(amount);
        }
      });
    }

    this.accountFacade.getBalance$()
      .subscribe((res) => {
        if (res !== undefined) {
          this.balanceAmount = res;
        }
        this.cdRef.markForCheck();
      });
  }

  betAmount(): void {

    if (
      Number(this.amount) < this.minBet ||
      Number(this.amount) > this.maxBet
    ) {
      this.showAlertInfo('Info', 'Please enter valid amount.', 'Close', 0);
      return;
    }

    // if (this.amount > 100) {
    //   this.showAlertInfo('Info', 'Bet amount must not exceed $100.', 'Close', 0);
    //   return;
    // }

    // if (this.amount > this.balanceAmount) {
    //   this.showAlertInfo('Error', 'Insufficient Funds.', 'Deposit Now button.', 1);
    //   return;
    // }

    // if (this.amount <= this.balanceAmount) {
      this.modalCtrl.dismiss({amount: this.amount, minBet: this.minBet, maxBet: this.maxBet});
    //   return;
    // }
  }

  inputAmount($event: any, amount: number): void {
    this.amount = amount;
    this.showConfirmBtn = amount ? true : false;
    if ($event.key === 'Enter') {
      this.modalCtrl.dismiss({amount: this.amount, minBet: this.minBet, maxBet: this.maxBet});
    }
  }

  chooseAmount(amount: number): void {
    // this.amount = amount;
    this.modalCtrl.dismiss({amount: amount, minBet: this.minBet, maxBet: this.maxBet});
  }

  confirm(): void {
    this.modalCtrl.dismiss({amount: this.amount, minBet: this.minBet, maxBet: this.maxBet});
  }

  close() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  async openFunding(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FundingComponent,
    });
    modal.present();
  }

  async showAlertInfo(hdr: string, msg: string, btn: string, status: number): Promise<void> {
    const alert = await this.alertCtrl.create({
      header: hdr,
      message: msg,
      buttons: [
        {
          text: btn,
          handler: () => {
            this.ngZone.run(()=>{
              if (status) {
                this.modalCtrl.dismiss();
                this.openFunding();
              }
            });
          }
        }
      ]
    });

    await alert.present();
  }

}
